import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

const FavoritesLimitReachedModalDialog = () =>
  import(/* webpackChunkName: "4-feat-favorites-limit-reached-modal-dialog" */ './FavoritesLimitReachedModalDialog');

const LoadableFavoritesLimitReachedModalDialog: ComponentType = lazyLoadOnRender({
  loader: FavoritesLimitReachedModalDialog,
});
export default LoadableFavoritesLimitReachedModalDialog;
